export let culture = {
    locale: "en-US",
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    dateFormat: 'mm/dd/yy',
    datePlaceholder: 'mm/dd/yyyy',
    monthDayFormat: 'mm/dd',
    weekHeader: 'Wk',
    firstDay: 0,
    shortFormat: "M d",
    mediumFormat: "M d, y",
    mediumFullYearFormat: "M d, yy",
    monthShortFormat: "M yy",
    yearFormat: "yy",
    FullFormat: "M dd, yy",
    LongTimeFormat: 'h:mm:ss TT',
    shortTimeFormat: 'h:mm TT',
    decimalSeparator: ".",
    currencyDecimalSeparator: '.',
    currencyGroupSeparator: ',',
    moneyWithCurrencyFormat: "{c}{v}",
    from: 'From',
    by: 'By',
    fromFormat: 'From {0}',
    byFormat: 'By {0}',
};

culture.getOrdinalNumSuffix = function (num) {
    /*
        see https://en.wikipedia.org/wiki/Ordinal_indicator#English

        -st is used with numbers ending in 1 (e.g. 1st, pronounced first)
        -nd is used with numbers ending in 2 (e.g. 92nd, pronounced ninety-second)
        -rd is used with numbers ending in 3 (e.g. 33rd, pronounced thirty-third)
        As an exception to the above rules, all the "teen" numbers ending with 11, 12 or 13 use -th (e.g. 11th, pronounced eleventh, 112th, pronounced one hundred [and] twelfth)
        -th is used for all other numbers (e.g. 9th, pronounced ninth).

        */
    var i = num % 100;
    if(i < 11 || i > 13) {
        var n = num % 10;
        if (n === 1)
            return "st";
        if (n === 2)
            return "nd";
        if (n === 3)
            return "rd";
    }

    return "th";
};
